module.exports = __webpack_public_path__ + "img/bg_data-science.76fe5aae.jpg";